import React from "react";
import styled from "styled-components";

import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";

const Styles = styled.div`
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .col {
    align-content: center;
    align-self: center;
  }

  a {
    color: white;
  }
  h5 {
    color: white;
    font-weight: 600;
  }
  .footer {
    background-color: #40817a;
    padding: 1rem;
  }

  .footer .footer-heading {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .footer-links h5 {
    margin-bottom: 1rem;
  }
`;
export const Footer = (props) => (
  <Styles>
    <footer className="footer">
      <Container fluid>
        <Row xs={1} md={1} lg={1} sm={1} className="text-center">
          <Col>
            <Container className="footer-heading">
              <p>Secureस्थल</p>
            </Container>
          </Col>
        </Row>
        <Row xs={2} sm={4} md={4} lg={4} className="text-center footer-links">
          <Col>
            <Container>
              <h5>Useful Links</h5>
            </Container>
          </Col>
          <Col>
            <Container>
              <h5>Our Services</h5>
            </Container>
          </Col>
          <Col>
            <Container>
              <h5>
                <a href="/contact-us">Contact Us</a>
              </h5>
            </Container>
          </Col>
          <Col>
            <Container>
              <h5><a href="/about">About Us</a></h5>
            </Container>
          </Col>
        </Row>
        <Row xs={1} md={1} lg={1} sm={1} className="text-center">
          <Col>
            <Container>
              <div>
                <a href=".">Amity University Mumbai </a>

                <span>&copy; 2020 AIBAS+ASET</span>
              </div>
            </Container>
          </Col>
        </Row>
      </Container>
    </footer>
  </Styles>
);
